var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 233,
    viewBox: "0 0 248 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.031 1.43582C196.031 -6.25855 217.12 17.9034 233.986 51.6325C279.241 142.133 207.709 233 121.944 233C-8.49781 233 -9.34701 126.744 7.71175 102.928C31.0691 70.3188 74.1343 76.5476 89.0976 55.6628C104.061 34.7781 106.251 7.55761 146.031 1.43582Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.7881,
    y1: 84.2718,
    x2: 224.307,
    y2: 166.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46109B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.9e6c258a7d33aeb6f2f6be4f4da0a8bc.svg";
export { ForwardRef as ReactComponent };